import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
import {
    Button,
    FormGroup,
    Col,
    Panel,
    Grid,
    Row
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import submit from './submit';
import validate from './validate';
import SafetyImageUploader from './SafetyImageUploader';
import InputFieldComponent from '../../../Common/FormField/InputFieldComponent';

import messages from '../../../../locale/messages';
import { safetyPageDefaults } from '../../../../helpers/safetyPageDefaults';

import s from './SafetyPageForm.css';
import bt from '../../../commonStyle.css';

const featureNumbers = [1, 2, 3];

class SafetyPageForm extends Component {

    render() {
        const { error, handleSubmit, submitting } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Grid fluid>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <h1 className={s.siteAdminHeading}>
                            <FormattedMessage {...messages.safetyLanding} />
                        </h1>
                    </Col>
                    <Col xs={12} sm={12} md={9} lg={8} className={s.blockCenter}>
                        <Panel className={cx(s.panelHeader)}>
                            <form onSubmit={handleSubmit(submit)}>
                                {error && <strong>{formatMessage(error)}</strong>}

                                <div className={s.formSection}>
                                    <h2 className={cx(s.siteAdminSubHeading, s.sectionHeading)}>
                                        <FormattedMessage {...messages.safetyHeroSection} />
                                    </h2>

                                    <FormGroup className={cx(bt.space4, s.imageField)}>
                                        <SafetyImageUploader
                                            form="SafetyPageForm"
                                            fieldName="heroBackgroundImage"
                                            postUrl="/uploadSafetyBanner"
                                            loaderName="safetyBannerLoader"
                                            label={formatMessage(messages.safetyBannerLabel)}
                                            defaultImage={safetyPageDefaults.heroBackgroundImage}
                                        />
                                    </FormGroup>

                                    <Field
                                        name="heroBadge"
                                        type="text"
                                        component={InputFieldComponent}
                                        label={formatMessage(messages.safetyBadgeLabel)}
                                        inputClass={bt.commonControlInput}
                                        formGroupClass={bt.space4}
                                    />
                                    <Field
                                        name="heroTitle"
                                        type="text"
                                        component={InputFieldComponent}
                                        label={formatMessage(messages.safetyHeroTitleLabel)}
                                        inputClass={bt.commonControlInput}
                                        formGroupClass={bt.space4}
                                    />
                                    <Field
                                        name="heroSubtitle"
                                        component={InputFieldComponent}
                                        componentClass={'textarea'}
                                        label={formatMessage(messages.safetyHeroSubtitleLabel)}
                                        inputClass={bt.commonControlTextArea}
                                        formGroupClass={bt.space4}
                                    />
                                    <Field
                                        name="heroDescription"
                                        component={InputFieldComponent}
                                        componentClass={'textarea'}
                                        label={formatMessage(messages.safetyHeroDescriptionLabel)}
                                        note={formatMessage(messages.safetyHeroDescriptionNote)}
                                        inputClass={bt.commonControlTextArea}
                                        formGroupClass={bt.space4}
                                    />
                                </div>

                                <div className={s.formSection}>
                                    <h2 className={cx(s.siteAdminSubHeading, s.sectionHeading)}>
                                        <FormattedMessage {...messages.safetyFeaturesSection} />
                                    </h2>

                                    {featureNumbers.map(index => (
                                        <div key={index}>
                                            <Field
                                                name={`feature${index}Title`}
                                                type="text"
                                                component={InputFieldComponent}
                                                label={formatMessage(messages.safetyFeatureTitleLabel)}
                                                labelNumber={String(index)}
                                                inputClass={bt.commonControlInput}
                                                formGroupClass={bt.space4}
                                            />
                                            <Field
                                                name={`feature${index}Description`}
                                                component={InputFieldComponent}
                                                componentClass={'textarea'}
                                                label={formatMessage(messages.safetyFeatureDescriptionLabel)}
                                                labelNumber={String(index)}
                                                inputClass={bt.commonControlTextArea}
                                                formGroupClass={bt.space4}
                                            />
                                            <FormGroup className={cx(bt.space4, s.imageField)}>
                                                <SafetyImageUploader
                                                    form="SafetyPageForm"
                                                    fieldName={`feature${index}Icon`}
                                                    postUrl="/uploadSafetyIcon"
                                                    loaderName={`safetyFeature${index}IconLoader`}
                                                    label={`${formatMessage(messages.safetyFeatureIconLabel)} ${index}`}
                                                />
                                            </FormGroup>
                                        </div>
                                    ))}
                                </div>

                                <div className={s.formSection}>
                                    <h2 className={cx(s.siteAdminSubHeading, s.sectionHeading)}>
                                        <FormattedMessage {...messages.safetyBottomCardSection} />
                                    </h2>

                                    <Field
                                        name="bottomCardTitle"
                                        component={InputFieldComponent}
                                        componentClass={'textarea'}
                                        label={formatMessage(messages.safetyBottomCardTitleLabel)}
                                        inputClass={bt.commonControlTextArea}
                                        formGroupClass={bt.space4}
                                    />
                                    <Field
                                        name="bottomCardText"
                                        component={InputFieldComponent}
                                        componentClass={'textarea'}
                                        label={formatMessage(messages.safetyBottomCardTextLabel)}
                                        inputClass={bt.commonControlTextArea}
                                        formGroupClass={bt.space4}
                                    />
                                </div>

                                <div className={s.actions}>
                                    <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting}>
                                        <FormattedMessage {...messages.save} />
                                    </Button>
                                </div>
                            </form>
                        </Panel>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

SafetyPageForm = reduxForm({
    form: 'SafetyPageForm',
    validate,
})(SafetyPageForm);

export default injectIntl(withStyles(s, bt)(SafetyPageForm));
